export const RESET_RESERVATION_AVAILABILITY = 'RESET_RESERVATION_AVAILABILITY';
export const RESET_RESERVATION_AVAILABILITY_ISFETCHING =
  'RESET_RESERVATION_AVAILABILITY_ISFETCHING';
export const LIST_RESERVATION_AVAILABILITIES_REQUEST =
  'LIST_RESERVATION_AVAILABILITIES_REQUEST';
export const RESERVATION_AVAILABILITY_LIST_REQUESTING =
  'RESERVATION_AVAILABILITY_LIST_REQUESTING';
export const LIST_RESERVATION_AVAILABILITIES_SUCCESS =
  'LIST_RESERVATION_AVAILABILITIES_SUCCESS';
